import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/Dashboard/InsightsSlider.css'
const CampaignInsights = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const insights = [
    {
      id: 1,
      title: "Campaign 1",
      message: "Your clicks increased across 1 campaign",
      type: "clicks",
      isPositive: true
    },
    {
      id: 2,
      title: "Campaign 2", 
      message: "Your cost decreased across 1 campaign",
      type: "cost",
      isPositive: false
    },
    {
      id: 3,
      title: "Campaign 1",
      message: "Your clicks increased across 1 campaign", 
      type: "clicks",
      isPositive: true
    },
    {
      id: 4,
      title: "Campaign 2",
      message: "Your cost decreased across 1 campaign",
      type: "cost",
      isPositive: false
    }
  ];

  const slidesToShow = 3;
  const totalSlides = Math.ceil(insights.length / slidesToShow);

  const nextSlide = () => {
    setCurrentSlide((prev) => 
      prev === totalSlides - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => 
      prev === 0 ? totalSlides - 1 : prev - 1
    );
  };

  return (
    <div className="campaign-insights">
      <div className="insight-container">
        <div className="left-section">
          <div className="logo-container">
            <img src='https://cdn.worldvectorlogo.com/logos/shopify.svg' height={50} width={50}></img>
          </div>
          <h2>Campaigns</h2>
          <p>Understand what's driving significant shifts for your campaigns</p>
        </div>

        <div className="right-section">
          <div className="headers d-flex justify-content-between my-3">
            <span className="insight-label">
              <svg className="performance-icon" viewBox="0 0 24 24" width="16" height="16">
                <path d="M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2 2H5V5h14v14zm0-16H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
              </svg>
              PERFORMANCE INSIGHT
            </span>
            <div className="navigation-buttons">
              <button onClick={prevSlide} className="nav-btn">
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
                </svg>
              </button>
              <button onClick={nextSlide} className="nav-btn">
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/>
                </svg>
              </button>
            </div>
          </div>

          <div className="insights-wrapper">
            <div className="insights-slider">
              <div 
                className="slides-container"
                style={{ 
                  transform: `translateX(-${currentSlide * (100 / slidesToShow)}%)`,
                  display: 'grid',
                  gridTemplateColumns: `repeat(${insights.length}, ${100 / slidesToShow}%)`,
                  gap: '20px',
                  padding: '0 10px'
                }}
              >
                {insights.map((insight, index) => (
                  <div key={insight.id} className="insight-slide">
                    <h3>{insight.title}</h3>
                    <p>{insight.message}</p>
                    <div className={`metric ${insight.type} ${insight.isPositive ? 'positive' : 'negative'}`}>
                      {insight.isPositive ? (
                        <svg className="arrow-icon up" viewBox="0 0 24 24" width="14" height="14">
                          <path d="M7 14l5-5 5 5z"/>
                        </svg>
                      ) : (
                        <svg className="arrow-icon down" viewBox="0 0 24 24" width="14" height="14">
                          <path d="M7 10l5 5 5-5z"/>
                        </svg>
                      )}
                      {insight.type === 'clicks' ? 'Clicks' : 'Cost'}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="slider-dots">
            {[...Array(totalSlides)].map((_, index) => (
              <span 
                key={index}
                className={`dot ${currentSlide === index ? 'active' : ''}`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignInsights;